import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class DpcCarousel extends React.Component {

    constructor(props) {
        super(props);
        this.settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: Math.min(this.props.itemsPerPage, this.props.items.length),
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                }
            }]

        };
    }

    render() {
        return (
            <Slider {...this.settings}>
                {
                    this.props.items.map(img =>
                        <div className="it-single-slide-wrapper">
                            <div className="card-wrapper">
                                <div className="card card-img no-after">
                                    <div className="img-responsive-wrapper">
                                        <div className="img-responsive">
                                            {img.categoria?.toLowerCase() === 'video' ?
                                                <embed className="embed-responsive-item"
                                                       src={img.src}
                                                       title={img.linkTitle}/> :
                                                <div className="img-wrapper">
                                                    <img alt={img.alt} src={img.src}/>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="category-top">
                                            <span
                                                className="category">{['galleria_foto', "galleria_flickr", "immagine"].includes(img.categoria?.toLowerCase()) ? 'Foto' : 'Video'}</span>
                                        </div>
                                        <h4 className="card-title"><a href={img.link}
                                                                      title={'Vai al sito ' + img.linkTitle}>{img.linkTitle}</a>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                }
            </Slider>
        )
    }

}
